var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "m-vacation" },
    [
      _c("remove-vacation-modal", {
        ref: "removeVacationModal",
        on: { remove: _vm.onRemove },
      }),
      _c(
        "b-modal",
        {
          attrs: {
            id: "vacation-modal",
            size: "custom-size",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          on: { close: _vm.close },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "vacation-modal-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: { click: _vm.close },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c("div", { staticClass: "vacation-modal-title" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } }),
          ]),
          _c(
            "div",
            {
              staticClass: "m-vacation-form",
              class: {
                "m-vacation-form--readonly": !_vm.canEdit,
              },
            },
            [
              !_vm.id
                ? _c(
                    "div",
                    { staticClass: "m-vacation-form__type" },
                    [
                      _c("c-switcher", {
                        staticClass: "h-switcher",
                        attrs: {
                          type: "group",
                          items: [
                            { label: "Отпуск", value: "vacation" },
                            { label: "Больничный", value: "sick" },
                          ],
                        },
                        model: {
                          value: _vm.form.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "type", $$v)
                          },
                          expression: "form.type",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.id
                ? _c(
                    "div",
                    { staticClass: "m-vacation-form__employee" },
                    [
                      _c("c-input2", {
                        attrs: {
                          type: "select",
                          "floating-label": "Сотрудник",
                          searchable: true,
                          clearable: true,
                          items: _vm.collections.employees,
                          required: _vm.employeeError,
                          "required-condition": _vm.employeeError,
                        },
                        model: {
                          value: _vm.form.employee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "employee", $$v)
                          },
                          expression: "form.employee",
                        },
                      }),
                      _vm.employeeError
                        ? _c("error-feedback", {
                            attrs: { text: _vm.employeeError },
                          })
                        : _vm._e(),
                      _vm.form.employee
                        ? _c("div", { staticClass: "employee-data" }, [
                            _c(
                              "span",
                              { staticClass: "employee-data__posts" },
                              [_vm._v(_vm._s(_vm.form.employee.workerPosts))]
                            ),
                            _c(
                              "span",
                              { staticClass: "employee-data__filials" },
                              [_vm._v(_vm._s(_vm.form.employee.filialName))]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.id && _vm.form.employee
                ? _c("div", { staticClass: "m-vacation-form__employee" }, [
                    _c("div", { staticClass: "employee" }, [
                      _c("div", { staticClass: "employee__wrapper" }, [
                        _vm.worker.photo
                          ? _c(
                              "div",
                              {
                                directives: [
                                  { name: "viewer", rawName: "v-viewer" },
                                ],
                                staticClass: "employee__avatar cursor-pointer",
                              },
                              [
                                _c("img", {
                                  attrs: { src: _vm.worker.photo, alt: "" },
                                }),
                              ]
                            )
                          : _vm._e(),
                        !_vm.worker.photo
                          ? _c("div", { staticClass: "employee__avatar" }, [
                              _c("img", {
                                attrs: { src: _vm.placeholder, alt: "" },
                              }),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "employee__data" }, [
                          _c("div", { staticClass: "employee__name" }, [
                            _vm._v(_vm._s(_vm.form.employee.label)),
                          ]),
                          _vm.form.employee.workerPosts ||
                          _vm.form.employee.filialName
                            ? _c("div", { staticClass: "employee__meta" }, [
                                _vm.form.employee.workerPosts
                                  ? _c(
                                      "div",
                                      { staticClass: "employee__posts" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.form.employee.workerPosts
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.form.employee.filialName
                                  ? _c(
                                      "div",
                                      { staticClass: "employee__filials" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.form.employee.filialName
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c("transition", { attrs: { name: "slide" } }, [
                _vm.canEdit && _vm.form.type === "vacation"
                  ? _c(
                      "div",
                      { staticClass: "m-vacation-form__vacation-type" },
                      [
                        _c("c-input2", {
                          attrs: {
                            type: "select",
                            "floating-label": "Тип отпуска",
                            searchable: true,
                            clearable: true,
                            items: _vm.collections.vacationTypes,
                            required: _vm.vacationTypeError,
                            "required-condition": _vm.vacationTypeError,
                          },
                          model: {
                            value: _vm.form.vacationType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "vacationType", $$v)
                            },
                            expression: "form.vacationType",
                          },
                        }),
                        _vm.vacationTypeError
                          ? _c("error-feedback", {
                              attrs: { text: _vm.vacationTypeError },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm.canEdit
                ? _c(
                    "div",
                    { staticClass: "m-vacation-form__period" },
                    [
                      _c("div", { staticClass: "label" }, [_vm._v("Период")]),
                      _c("c-period", {
                        ref: "period",
                        attrs: { required: true },
                        model: {
                          value: _vm.form.period,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "period", $$v)
                          },
                          expression: "form.period",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.canEdit
                ? _c("div", { staticClass: "m-vacation-form__period" }, [
                    _c("div", { staticClass: "period" }, [
                      _c("div", { staticClass: "period__label" }, [
                        _vm._v("Период"),
                      ]),
                      _c("div", { staticClass: "period__value" }, [
                        _vm._v(
                          _vm._s(_vm.form.period.start) +
                            "–" +
                            _vm._s(_vm.form.period.end)
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "m-vacation-form__file" },
                [
                  _c("file-loader", {
                    ref: "loader",
                    attrs: {
                      limit: 1,
                      format: "images,pdf",
                      actions: "loadFiles,loadImages,preview",
                      links: _vm.fileLinks,
                    },
                    on: {
                      changeLinks: function ($event) {
                        _vm.fileLink = $event[0]
                      },
                    },
                    model: {
                      value: _vm.files,
                      callback: function ($$v) {
                        _vm.files = $$v
                      },
                      expression: "files",
                    },
                  }),
                ],
                1
              ),
              _vm.serverError
                ? _c("error-feedback", {
                    staticClass: "mt-4",
                    attrs: { text: _vm.serverError },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "m-vacation-form__actions" },
            [
              _vm.id && _vm.canEdit
                ? _c("c-button", {
                    staticClass: "m-vacation-form__remove",
                    attrs: { size: "large", label: "Удалить", color: "pink" },
                    on: { click: _vm.remove },
                  })
                : _vm._e(),
              _vm.id && _vm.canEdit
                ? _c("c-button2", {
                    staticClass: "m-vacation-form__remove-m",
                    attrs: { icon: "trash", color: "secondary" },
                    on: { click: _vm.remove },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex m-vacation-form__actions-container ml-auto",
                },
                [
                  !_vm.canEdit
                    ? _c("c-button", {
                        staticClass: "m-vacation-form__reset",
                        attrs: { size: "large", label: "Закрыть" },
                        on: { click: _vm.close },
                      })
                    : _vm._e(),
                  _vm.canEdit
                    ? _c("c-button", {
                        staticClass: "m-vacation-form__reset",
                        attrs: { size: "large", label: "Отменить" },
                        on: { click: _vm.close },
                      })
                    : _vm._e(),
                  _vm.canEdit
                    ? _c("c-button", {
                        staticClass: "m-vacation-form__apply",
                        attrs: {
                          size: "large",
                          label: "Сохранить",
                          color: "blue",
                        },
                        on: { click: _vm.submit },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }